import { httpExtract } from '../../../utils/api.utils';
import { saveAs } from 'file-saver';
import { toPng } from 'html-to-image';

import {
  exportPowerPointSuccess,
  exportPowerPointFailure,
  exportPdfSuccess,
  exportPdfFailure
} from '../../../constants/model-reducers/external/extract/extract.setting';

const initialState = {
    isExportLoaded: false,
    isExportError: null,
  };

  export const extractAction = {
    exportToPowerPoint: (chartElements, circuitCode) => {
        return async (dispatch) => { 
        const fileName = `Usage Spend of ` + circuitCode;
        function dataUrlToBlob(dataUrl) {
          const base64Data = dataUrl.split(",")[1];
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);         
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'image/png' });  
          return blob;
        }
  
        try {
          const formData = new FormData();  
          for(let i=0; i<chartElements.length; i++){       
            if (chartElements[i]) {
                const dataUrl = await toPng(chartElements[i]);                
                if (dataUrl) {
                    const blob = dataUrlToBlob(dataUrl);
                    formData.append('image' + i, blob);
                }
            }
        }
      
          const response = await httpExtract('external/extract/download-ppt', formData, {}, true)        
          const powerPointBlob = await response.blob();        
          saveAs(powerPointBlob, fileName + '.pptx');        
          dispatch({
            type:exportPowerPointSuccess,
            isExportLoaded:false,
            isExportError:false
          });
          return Promise.resolve();
        } catch (error) {
          dispatch({
            type:exportPowerPointFailure,
            isExportError:true,
            isExportLoaded:false
          });
          console.log(error)
          return Promise.reject(error);
        }
      };
    },

    exportToPDF: (chartElements, circuitCode) => {
      const fileName = `Usage Spend of ` + circuitCode;
      return async (dispatch) => {         
        function dataUrlToBlob(dataUrl) {
          const base64Data = dataUrl.split(",")[1];
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'image/png' });  
          return blob;
        }
  
        try {
          const formData = new FormData();  
          for(let i=0; i<chartElements.length; i++){
            if (chartElements[i]) {
                const dataUrl = await toPng(chartElements[i]);
                if (dataUrl) {
                    const blob = dataUrlToBlob(dataUrl);
                    formData.append('image' + i, blob);
                }
            }
        }      
          const response = await httpExtract('external/extract/download-pdf', formData, {}, true)        
          const pdfBlob = await response.blob();        
          saveAs(pdfBlob, fileName + '.pdf');        
          dispatch({
            type:exportPdfSuccess,
            isExportLoaded:false,
            isExportError:false
          });
        } catch (error) {
          dispatch({
            type:exportPdfFailure,
            isExportError:true,
            isExportLoaded:false
          });
          console.log(error)
        }
      };
    }
    
}
    

export const reducer=(state,action)=>{
    state = state || initialState;
    switch (action.type){       
        case exportPowerPointSuccess:
            return {
                ...state,
                isExportLoaded:action.isExportLoaded
            };
        case exportPowerPointFailure:
            return{
                ...state,
                isExportLoaded:action.isExportLoaded,
                error: action.isExportError
            };
        case exportPdfSuccess:
              return {
                  ...state,
                  isExportLoaded:action.isExportLoaded
              };
        case exportPdfFailure:
              return{
                  ...state,
                  isExportLoaded:action.isExportLoaded,
                  error: action.isExportError
              }
        default:
            return state;
    }
}